import parse from 'html-react-parser';
import { Button, Card } from "react-bootstrap";
import { useState } from "react";
import type { Course } from '~/models/course';
import { tags } from '~/utils/courses';
import { Link } from 'react-router';
import { SmartImage } from '~/components/utils/SmartImage';

interface Props {
    course: Course
}

export default function CourseCard({ course }: Props) {
    const [showMore, setShowMore] = useState(false);
    const text = course.shortDescription;
    const textLen = 175;
    const regex = /(<([^>]+)>)/gi;
    const shortText = text.replace(regex, "").substring(0, textLen);

    return (
        <Card className="course-item">
            {/* Replace Card.Img with SmartImage */}
            <SmartImage
                className="card-img-top"    // Bootstrap’s class to keep styling
                cldUrl={course.thumbnail || undefined}
                src={course.thumbnail || '/assets/img/defaultCourse.jpeg'} 
                alt={course.name}
                objectFit="cover"
            />
            <Card.Body className="course-content">
                <Card.Title as="div" className="d-flex justify-content-between align-items-center mb-3">
                    <Card.Title as="h4">{tags(course.tags)}</Card.Title>
                </Card.Title>

                <Card.Title as="h3">{course.name}</Card.Title>
                <Card.Text>
                    {
                        showMore ?
                            parse(text) :
                            shortText + (shortText.length < text.length ? '...' : '')
                    }
                    <br />
                    <>
                        {shortText.length < text.length &&
                            <Button className="showMore" variant="link" onClick={() => setShowMore(!showMore)}>{showMore ? 'Show Less' : 'Show More'}</Button>}
                    </>

                </Card.Text>
            </Card.Body>
            <Card.Footer className="trainer d-flex justify-content-between align-items-center">
                <Link role="button"
                    className="btn btn-primary"
                    to={`/courses/${course.tags[0].reference}/${course.reference}`}>Learn More</Link>
            </Card.Footer>
        </Card>
    )
}